export let WorkerProcessType = {
  clusterController: 'clustercontroller',
  gateway: 'gateway',
  vizportal: 'vizportal',
  vizqlServer: 'vizqlserver',
  cacheServer: 'cacheserver',
  searchServer: 'searchserver',
  backgrounder: 'backgrounder',
  dataServer: 'dataserver',
  dataEngine: 'dataengine',
  hyper: 'hyper',
  wgServer: 'wgserver',
  fileStore: 'filestore',
  repository: 'repository',
  flowProcessor: 'flowprocessor',
  metrics: 'metrics'
};

export interface WorkerProcess {
  host: string;
  type: string;
  port: string;
  preferred: boolean;
  isExternal?: boolean;
}
